/**
 * 访问资源api
 * date:2022 03 03
 */
 import httpRequest from '@/utils/request.js';

 /**查询菜单树 */
 export const pageOperateTree = (params = {}) => httpRequest.httpGet({
    url: '/service/url/page/tree', params: {
      ...params
    }
  })
 /**获取一条数据 */
 export const pageOperateDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/url/page/detail', params: {
      ...params
    }
  })
 /**添加 */
  export const pageOperateAdd = (data, loadingOptions) => httpRequest.httpPost('/service/url/page/add', data, loadingOptions)
 /**修改 */
  export const pageOperateUpdate = (data, loadingOptions) => httpRequest.httpPut('/service/url/page/update', data, loadingOptions)

  /**批量更新排序（拖拽排序专用，直接传数组不展开） */
  export const pageOperateBatchSort = (data, loadingOptions) => httpRequest.httpPut2('/service/url/page/batchSort', data, loadingOptions)

  /** 删除 */
  export const pageOperateDel = (data, loadingOptions) => httpRequest.httpdelete('/service/url/page/del', data, loadingOptions)

   /**获取url */
 export const urlResourceList = (params = {}) => httpRequest.httpGet({
  url: '/service/url/resource//page', params: {
    ...params
  }
})
   /**刷新url */
 export const urlResourceReset = (params = {}) => httpRequest.httpGet({
  url: '/service/url/resource//reset', params: {
    ...params
  }
})
   /**获取表格 */
 export const functionOperatePage = (params = {}) => httpRequest.httpGet({
  url: '/service/url/function/page', params: {
    ...params
  }
})

  /** 删除表格 */
  export const functionOperateDel = (data, loadingOptions) => httpRequest.httpdelete('/service/url/function/del', data, loadingOptions)
  
   /**单条添加 */
   export const functionOperateAdd = (data, loadingOptions) => httpRequest.httpPost('/service/url/function/add', data, loadingOptions)
   /**批量添加 */
   export const functionOperateAddPatch = (data, loadingOptions) => httpRequest.httpPost('/service/url/function/saveBatch', data, loadingOptions)
   /**修改 */
   export const functionOperateUpdate = (data, loadingOptions) => httpRequest.httpPut('/service/url/function/update', data, loadingOptions)
   /**保存url */
   export const pageOperateUpdateUrl = (data, loadingOptions) => httpRequest.httpPut('/service/url/page/updateUrl', data, loadingOptions)

   /** V8: 查询功能详情（弹出框编辑用，含 URL 列表） */
   export const functionDetail = (params = {}) => httpRequest.httpGet({
     url: '/service/url/function/detail', params: {
       ...params
     }
   })
   /** V8: 新增功能（含多 URL + 翻译） */
   export const functionSave = (data, loadingOptions) => httpRequest.httpPost('/service/url/function/save', data, loadingOptions)